import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Tabs } from '@frontend/design-system';
import { Container } from '../components/container';
import { DataSources } from './data-sources/data-sources';
import { LocationInfo } from './location-info/location-info';

type Props = { locationId: string };
export const Dashboard = ({ locationId }: Props) => {
  return (
    <main>
      <Container>
        <Tabs initialTab='location'>
          <Tabs.Bar
            css={{
              background: theme.colors.white,
              width: 'fit-content',
              borderTopRightRadius: '8px',
              borderTopLeftRadius: '8px',
            }}
          >
            <Tabs.Tab id='location'>Location Information</Tabs.Tab>
            <Tabs.Tab id='audit'>Audit Logs</Tabs.Tab>
          </Tabs.Bar>
          <Tabs.Panel controller='location' css={panel}>
            <LocationInfo locationId={locationId} />
            <DataSources locationId={locationId} />
          </Tabs.Panel>
          <Tabs.Panel controller='audit' css={panel}>
            Audit
          </Tabs.Panel>
        </Tabs>
      </Container>
    </main>
  );
};

const panel = css`
  padding-top: ${theme.spacing(2)};
`;
